// src/application/SidebarService.js
import { SidebarItem } from '../domain/SidebarItem';
import { getIcon } from '../infrastructure/IconProvider';

export class SidebarService {
    static getSidebarConfig(permissionArray) {
        const logoutItem = permissionArray.find(item => item.title === '登出');
        const filteredArray = permissionArray.filter(item => item.title !== '登出');
        if (logoutItem) {
            filteredArray.push(logoutItem);
        }
        return filteredArray.map(item => new SidebarItem(item.title, item.path, getIcon(item.icon)));
    }
}